import reducer from './offlineAvailability';
import { actionCreators, OfflineAvailabilityActionType } from './offlineAvailability.actionCreators';
import * as actionTypes from './offlineAvailability.actionTypes';

export * from './offlineAvailability'; // expose all types
export * from './offlineAvailability.selectors';
export type ActionType = OfflineAvailabilityActionType;
export { actionTypes, actionCreators };
export default reducer;
